import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * Bordered caption next to a title ("1 of 2"). Part-booked items render each
 * booking as a full peer row, so the tag is what tells them apart.
 */
export const PartTag = ({ children }: { children: ReactNode }) => (
  <Typography
    component="span"
    variant="caption"
    color="text.secondary"
    noWrap
    sx={{
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 0.75,
      px: 0.5,
      lineHeight: 1.5,
      flexShrink: 0,
    }}
  >
    {children}
  </Typography>
);
